import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import PropTypes from "prop-types";
import "./hero.css";

import { fetchHeroContent } from "../../features/hero/heroTypeActions";
import { ApplicationState } from "../../redux/initialState";
import { HeroType } from "../../features/hero/heroTypes";

import { Heading1, Heading5, useBreakpoint } from "@tal-gel/components-v2";
import styled from "@emotion/styled";

interface PropsFromState {
  loading: boolean;
  data: HeroType;
  errors?: string;
}

interface propsFromDispatch {
  fetchHeroContent: () => any;
}

type AllProps = PropsFromState & propsFromDispatch;

function isEmptyObject(obj: any) {
  return Object.keys(obj).length === 0;
}

const HeroContent: React.FC<AllProps> = ({ data, fetchHeroContent }) => {
  useEffect(() => {
    if (isEmptyObject(data)) {
      fetchHeroContent();
    }
  }, [data, fetchHeroContent]);

  const isXlScreen = useBreakpoint("xl");
  return (
    <div
      className="hero-image"
      style={{
        minWidth: isXlScreen ? 1200 : "100vw",
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${data.heroImage})`,
      }}
    >
      <RowLayout>
        <Heading1 style={{ color: "#fff" }}>{data.heroTitle}</Heading1>
        <Heading5 style={{ color: "#fff", textAlign: "center" }}>{data.heroDescription}</Heading5>
      </RowLayout>
    </div>
  );
};

const mapStateToProps = ({ heroType }: ApplicationState) => ({
  loading: heroType.loading,
  errors: heroType.errors,
  data: heroType.data,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    fetchHeroContent: () => {
      dispatch(fetchHeroContent());
    },
  };
};

HeroContent.propTypes = {
  loading: PropTypes.any,
  errors: PropTypes.string,
  data: PropTypes.any.isRequired,
  fetchHeroContent: PropTypes.func.isRequired,
};

const RowLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
`;

export default connect(mapStateToProps, mapDispatchToProps)(HeroContent);
